/**
 * Large Lead Query — travelling party with more than five adults (6+).
 * Legacy parity: daily tracker "Large Leads" column (adults-only).
 */
export const LARGE_LEAD_ADULTS_THRESHOLD = 5;

export function isLargeLeadQueryByAdults(travellerAdults: number): boolean {
  return travellerAdults > LARGE_LEAD_ADULTS_THRESHOLD;
}
